import { useEffect, useState } from 'react';

const useUserAgent = () => {
    const [userAgent, setUserAgent] = useState<string | null>(null);
    const [operatingSystem, setOperatingSystem] = useState<string>("web"); // Default source
    const [isChrome, setIsChrome] = useState<boolean>(false);
    const [isIOS, setIsIOS] = useState<boolean>(false);
    const [isIOSChrome, setIsIOSChrome] = useState<boolean>(false);

    useEffect(() => {
        if (typeof window !== "undefined" && navigator) {
            const ua = navigator.userAgent.toLowerCase();
            setUserAgent(ua);

            if (ua.includes("android")) {
                setOperatingSystem("android");
            } else if (
                ua.includes("iphone") ||
                ua.includes("ipad") ||
                ua.includes("ipod")
            ) {
                setOperatingSystem("ios");
            } else {
                setOperatingSystem("web");
            }

            // Set derived states
            setIsChrome(
                operatingSystem === "android" &&
                ua.includes("chrome") &&
                !ua.includes("edg") // Exclude Edge on Android
            );
            setIsIOS(operatingSystem === "ios"); // Set iOS state
            setIsIOSChrome(isIOS && ua.includes("crios")); // Check for iOS Chrome
        } else {
            setUserAgent("unknown");
        }
    }, [operatingSystem]); // Dependency on source to recalculate derived states

    return { userAgent, operatingSystem, isChrome, isIOS, isIOSChrome }; // Return all values
};

export default useUserAgent; // Exporting the custom hook